import { useEffect } from 'react'
import { upsertPushSubscription } from '../../services/pushSubscriptionService'
import { toByteArray } from 'base64-js'
import { useEnvironmentVariables } from './useEnvironmentVariables'

const urlBase64ToUint8Array = (base64String: string): Uint8Array => {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

	return toByteArray(base64)
}

export function useServiceWorkers(userId: number) {
	useEffect(() => {
		if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
			console.warn('Push notifications are not supported in this browser.')
			return
		}
		const subscribeUser = async () => {
			try {
				const registration = await navigator.serviceWorker.ready;
				const existingSubscription = await registration.pushManager.getSubscription()
				if (existingSubscription) return // user already subscribed

				const subscription = await registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: urlBase64ToUint8Array(useEnvironmentVariables().VAPID_PUBLIC_KEY),
				})

				await upsertPushSubscription({
					endpoint: subscription.endpoint,
					publicKey: subscription.toJSON().keys!.p256dh,
					auth: subscription.toJSON().keys!.auth,
				})
			} catch (error) {
				console.error('Push subscription failed:', error)
			}
		}
		subscribeUser()
	}, [userId])
}
